module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Topbar'), _vm._v(" "), _c('fieldset', {
    staticClass: "signup-form"
  }, [_c('legend', [_vm._v("Sign up")]), _vm._v(" "), _c('button', {
    staticClass: "google-btn",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.signupGoogle()
      }
    }
  }, [_c('img', {
    staticClass: "idp-btn-img",
    attrs: {
      "src": "/static/img/icons/google-g-logo.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idp-btn-text"
  }, [_vm._v("\n        sign in with google\n      ")])]), _vm._v(" "), _c('h4', [_vm._v("or using your e-mail")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signup()
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-email"
    }
  }, [_vm._v("E-Mail")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "email",
      "id": "signup-email",
      "placeholder": "tom@aol.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group full-width",
    class: {
      invalid: !_vm.passwordPatternMatch
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-pw"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "password",
      "id": "signup-pw2",
      "pattern": ".{6,}",
      "placeholder": "**************",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v("Passwords should have at least 6 characters.")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group full-width",
    class: {
      invalid: !_vm.passwordsMatch
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-pw2"
    }
  }, [_vm._v("Repeat Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordRetype),
      expression: "passwordRetype"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "password",
      "id": "signup-pw2",
      "pattern": ".{6,}",
      "placeholder": "**************",
      "required": ""
    },
    domProps: {
      "value": (_vm.passwordRetype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordRetype = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v("Passwords don't match.")])]), _vm._v(" "), _c('button', {
    staticClass: "button acc",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.passwordsMatch || !_vm.passwordPatternMatch
    }
  }, [_vm._v("Sign up")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Have an account already?\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signin'
      }
    }
  }, [_vm._v("Sign in")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51caed0f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup.vue
// module id = 287
// module chunks = 1